module.exports = __webpack_public_path__ + "static/img/quxiaojingyin.ed8e69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quxiaojingyin.png
// module id = iFsl
// module chunks = 24